import { Turbo } from '@hotwired/turbo-rails';
import { showApiErrors, showFlashMessages, showHttpResponseJsonErrors } from '../../libs/cifra/flash';
import Overlay from '../../libs/cifra/overlay';
import { confirmarEliminarFromElement } from '../../libs/cifra/dialogs';
import { contentTypeIsJson, formPost } from '../../libs/http';

/**
 * TODO: Falta más gestión del resto de errores (ver flash.js) pero hay que
 * adaptarlos porque Turbo usa Fetch para hacer las peticiones y los métodos
 * de flash.js no están preparados para recibir dichos objetos
 */
function controlErroresRespuestaForm() {
  document.addEventListener('turbo:submit-end', (event) => {
    const { formSubmission } = event.detail;
    showFlashMessages(formSubmission.result?.fetchResponse?.response);

    if (formSubmission.result?.fetchResponse) {
      if (contentTypeIsJson(formSubmission.result.fetchResponse.response.contentType)) {
        formSubmission.result.fetchResponse.response.json()?.then((value) => {
          showApiErrors(value);
          showHttpResponseJsonErrors(value);
        });
      }
    }
  });

  document.addEventListener('turbo:before-fetch-response', (event) => {
    const { fetchResponse } = event.detail;
    showFlashMessages(fetchResponse?.response);
  });
}

// En el confirm de Turbo no tenemos acceso al link ni a sus datos, por eso hacemos la ñapa
// de buscar así el elemento original:
// https://github.com/hotwired/turbo/issues/811
function confirmConSwal(message, form, submitter) {
  let originalElement = submitter;

  if (!submitter) {
    const matchingElements = document.querySelectorAll(
      `a[data-turbo-confirm="${message}"][data-turbo-method="${form.getAttribute('method')}"]`,
    );
    // Los parámetros de la URL Turbo los mete como inputs ocultos dentro del form
    const inputs = [...form.querySelectorAll('input')];
    const params = inputs.map((input) => `${input.getAttribute('name')}=${input.value}`).join('&');
    const encodedParams = inputs.map((input) => `${input.getAttribute('name')}=${encodeURIComponent(input.value)}`).join('&');
    let formUrl = form.action;
    let formUrlEncoded = formUrl;
    if (params) {
      formUrl = `${formUrl}?${params}`;
      formUrlEncoded = `${formUrlEncoded}?${encodedParams}`;
    }
    // Ñapa, Buscamos la url con los parámetros codificados y sin codificar porque se pueden
    // dar ambos casos
    originalElement = [...matchingElements].find(
      (el) => formUrl.includes(el.href) || formUrlEncoded.includes(el.href),
    );
  }

  return confirmarEliminarFromElement(originalElement);
}

/**
 * La idea es que automáticamente cuando hagamos un botón con un confirm
 * para borrar algo, se ponga el overlay automáticamente
 */
function controlOverlayDelete() {
  let overlay;

  document.addEventListener('turbo:submit-start', (event) => {
    const { formSubmission } = event.detail;
    const method = formSubmission.formElement.getAttribute('method');
    if (method === 'delete') {
      overlay = new Overlay('body');
      overlay.show();
    }
  });

  document.addEventListener('turbo:submit-end', (_event) => {
    if (overlay) {
      overlay.hide();
      overlay = null;
    }
  });
}

Turbo.setProgressBarDelay(500);
Turbo.setConfirmMethod(confirmConSwal);

// Hay que poner la función así porque nos hará el binding con el this con la información
/* global Cifra */
// eslint-disable-next-line func-names
Turbo.StreamActions.load_components = function () {
  const target = this.targetElements[0];
  Cifra.App.loadComponents(target, {
    checkAutoload: true,
  });
};
/**
 * Acción para cerrar los modales abiertos
 */
/* global $,swal */
// eslint-disable-next-line func-names
Turbo.StreamActions.hide_modal = function () {
  $('.modal.in').modal('hide');
  swal.close();
};

// eslint-disable-next-line func-names
Turbo.StreamActions.full_reload = function () {
  if (this.getAttribute('overlay') !== 'false') {
    const overlay = new Overlay(document.body);
    overlay.show();
  }
  Turbo.visit(this.getAttribute('url'));
};

// eslint-disable-next-line func-names
Turbo.StreamActions.redirect_post = function () {
  const params = {};
  const opciones = {};
  if (this.getAttribute('target')) {
    opciones.target = this.getAttribute('target');
  }
  if (this.getAttribute('overlay')) {
    opciones.overlay = this.getAttribute('overlay');
  }

  formPost(this.getAttribute('url'), params, opciones);
};

/**
 * Lanza un evento global en el document
 */
// eslint-disable-next-line func-names
Turbo.StreamActions.document_event = function () {
  const detail = {};
  this.attributes.forEach((attribute) => {
    detail[attribute.name] = attribute.value;
  });

  const evento = new CustomEvent(
    this.getAttribute('event_name'),
    { detail },
  );
  window.document.dispatchEvent(evento);
};

// Que no cachee nada ni preview ni nada
// Muy importante poner también en el <head>
// <meta name="turbo-cache-control" content="no-cache"></meta>
// Porque si no según qué llamadas, se activa la caché no sé por qué.
// Además lo vamos a forzar cada vez que turbo carga cualquier cosa
document.addEventListener('turbo:load', () => {
  Turbo.cache.exemptPageFromCache();
});
Turbo.cache.exemptPageFromCache();

// Como Turbo cache está desactivado, Turbo no restaura el scroll automáticamente
// al volver a una página (ej: al editar un elemento de tabla y guardar). Guardamos
// window.scrollY en sessionStorage antes de salir y lo restauramos al cargar.
function controlScrollAlVolver() {
  document.addEventListener('turbo:before-visit', () => {
    sessionStorage.setItem(`scroll:${window.location.pathname}`, window.scrollY);
  });

  document.addEventListener('turbo:load', () => {
    const key = `scroll:${window.location.pathname}`;
    const scrollY = sessionStorage.getItem(key);
    if (scrollY) {
      window.scrollTo(0, parseInt(scrollY, 10));
      sessionStorage.removeItem(key);
    }
  });
}

controlErroresRespuestaForm();
controlOverlayDelete();
controlScrollAlVolver();

export {
  // eslint-disable-next-line import/prefer-default-export
  Turbo,
};
